import { render, staticRenderFns } from "./ChatCommentsIcon.vue?vue&type=template&id=17b3c1f7&"
import script from "./ChatCommentsIcon.vue?vue&type=script&lang=ts&"
export * from "./ChatCommentsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports